<template>
    <div class="mt-5">
	    <!-- Question -->
	    <div v-if="data.meta" class="d-flex flex-column gap-3 text-center mb-5">
		    <h3 v-if="questionDescription" class="fw-semi-bold m-0" v-html="questionDescription"></h3>
		    <p v-if="questionSubText" class="text-secondary m-0" v-html="questionSubText"></p>
	    </div>

        <!-- Input -->
        <ul class="list-group text-start">
            <li v-for="option in data.options" :key="option.id"
                class="cursor-pointer d-flex align-items-center list-group-item fs-6 border-0 p-0">
                <input class="form-check-input mt-0" :id="option.id" type="radio" :name="data.meta.inputName"
                    v-model="selectedOption" :value="option.value">
                <label class="form-check-label cursor-pointer p-2 flex-grow-1" :for="option.id">
                    {{ option.text }}
                </label>
            </li>
        </ul>

        <!-- Error message -->
        <p v-if="selectedOption == null && !data.skippable" class="text-danger my-3">Please select an option</p>
    </div>
</template>

<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
	questionDescription: String,
	questionSubText: String,
    data: Object,
	answer: {
		type: Array,
		default: () => []
	}
});

const selectedOption = ref(props.answer.length > 0 ? props.answer[0].value : null);

const emit = defineEmits(['question-answered']);
watch(selectedOption, (newVal, oldVal) => {
	let answerToReturn = [
		{
			value: newVal,
			text: props.data.options.find(opt => opt.value === newVal)?.text || ''
		}
	]
    emit('question-answered', answerToReturn);
})
</script>